<template>
  <div>
    <v-row>
      <v-col cols="12"><h1 class="font-weight-thin">Dropdown Administration</h1></v-col>
    </v-row>
    <v-card class="elevation-0">
      <v-card-text>
        <v-data-table :headers="headerList" :hide-default-footer="true" :items="dropdownList" disable-pagination>
          <template v-slot:item="{ item }">
            <tr>
              <td data-cy="label">{{ item.label }}</td>
              <td data-cy="attributeName">{{ item.attributeName }}</td>
              <td>
                <v-btn
                  @click="$router.push({ name: 'adminDropdown', params: { id: item.id } })"
                  color="primary"
                  data-cy="edit"
                  outlined
                  small
                  >Edit</v-btn
                >
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      dropdownList: state => state.admin.dropdown.list,
    }),
  },
  async created() {
    try {
      await this.fetchDropdownList();
    } catch (e) {
      console.error(e);
      return this.fetchDropdownListError();
    }
  },
  data() {
    return {
      headerList: [
        {
          text: "Dropdown",
          value: "label",
        },
        {
          text: "Attribute Name",
          value: "attributeName",
        },
        {
          sortable: false,
          value: "actions",
        },
      ],
      showForm: false,
    };
  },
  methods: {
    ...mapActions({
      fetchDropdownList: "admin/dropdown/list",
    }),
    ...mapMutations({
      setEdit: "admin/dropdown/setEdit",
    }),
  },
  notifications: {
    fetchDropdownListError: {
      title: "Error!",
      message: "Error fetching dropdown list.",
      type: "error",
    },
  },
};
</script>
